import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ActivityLogResponse } from '../../../types/ActivityLog';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

type UseGetAllActivityLogsParams = {
  page?: number;
  per_page?: number;
  filters?: {
    owner_uuid?: string;
    owner_type?: string;
  };
};

export type UseGetAllActivityLogsProps = {
  params?: UseGetAllActivityLogsParams;
  enabled?: boolean;
};

export const fetchAllActivityLogs = async ({ params }: UseGetAllActivityLogsProps) => {
  const response = await CustomAxios.get<ActivityLogResponse>(`/activity_logs`, { params });
  const { data } = response;
  return data;
};

export function useGetAllActivityLogs({ params, enabled = true }: UseGetAllActivityLogsProps) {
  const queryKey = [queryKeys.allActivityLogs, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllActivityLogs({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
